import React from "react";
import {component_tool} from '@/tool'
import {WizBraftEditorPlus} from "@/containers/common";

let {
  WizComponent,
  WizModal,
  WizButton,
} = component_tool;

class ModalDescriptionView extends WizComponent {
  constructor(props) {
    super(props);
    let {value} = props
    this.state = {
      visible: false,
      data: value,
    }
  }

  onHidden = () => {
    this.setState({visible: false}, () => {
      let {value} = this.props
      this._ref.resetContent(value)
    })
  }
  onShow = () => {
    this.setState({visible: true})
  }
  onOk = () => {
    this.setState({visible: false}, () => {
      let {onChange} = this.props
      let {data} = this.state
      onChange && onChange(data)
    })
  }

  _onChange = (data) => {
    this.setState({data})
  }

  render() {
    let {value} = this.props;
    let {visible, data} = this.state;

    return (
      <>
        <div dangerouslySetInnerHTML={{__html: value?.length ? value : '请输入章节描述'}}/>
        <WizButton onClick={this.onShow}>编辑</WizButton>
        <WizModal
          width={700}
          visible={visible}
          centered={true}
          closable={false}
          onCancel={this.onHidden}
          onOk={this.onOk}
        >
          <WizBraftEditorPlus
            ref={ref => this._ref = ref && ref.getWrappedInstance()}
            placeholder='请输入章节描述'
            value={data}
            onChange={this._onChange}
          />
        </WizModal>
      </>
    )
  }
}


export default ModalDescriptionView

